/**
 * Copyright © IMPACT Commerce AB. All rights reserved.
 * See COPYING.txt for license details.
 */

import { DialogComponent } from '@theme/dialog';

/**
 * A generic custom element that manages a drawer dialog.
 * Can be extended or used directly for any drawer functionality.
 *
 * @extends {DialogComponent}
 */
class DrawerComponent extends DialogComponent {
  connectedCallback() {
    super.connectedCallback();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
  }

  open() {
    this.showDialog();
  }

  close() {
    this.closeDialog();
  }
}

// Register Product Variations Drawer (only once)
if (!customElements.get('product-variations-drawer')) {
  customElements.define('product-variations-drawer', class ProductVariationsDrawer extends DrawerComponent {});
}

// Register Variant Picker Drawer (only once)
if (!customElements.get('variant-picker-drawer')) {
  customElements.define('variant-picker-drawer', class VariantPickerDrawer extends DrawerComponent {});
}

// Collection / search facet filters drawer (PLP, search) — same DialogComponent API as dialog-component
if (!customElements.get('filters-drawer')) {
  customElements.define('filters-drawer', class FiltersDrawer extends DrawerComponent {});
}
